import { render, staticRenderFns } from "./listingg.vue?vue&type=template&id=0bc1264c&scoped=true&"
import script from "./listingg.vue?vue&type=script&lang=js&"
export * from "./listingg.vue?vue&type=script&lang=js&"
import style0 from "./listingg.vue?vue&type=style&index=0&id=0bc1264c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1264c",
  null
  
)

export default component.exports